import classnames from 'classnames'
import { useCallback, useMemo } from 'react'

import { useTrackIsElementVisible } from '@src/quince-site-common/src/hooks/useTrackIsElementVisible'
import { getSanitizedHtml } from '@src/quince-site-common/src/utils/getSanitizedHtml'

import styles from './productOfferMessage.module.scss'
import { getTrackerAddedComboMessageOffer } from './utils'

import type { ProductOfferMessageProps } from './product-offer-message.types'

export const ProductOfferMessageLegacy = (props: ProductOfferMessageProps) => {
  const { productId, offerMessageFromPC, showNewPdpDesignV2 } = props
  const getIsVisibleTrackParams = useCallback(
    () => ({
      action: 'pdp_offer_message',
      value: true,
      context: {
        productId,
      },
    }),
    [productId],
  )
  const { ref: trackIsVisibleRef } = useTrackIsElementVisible(getIsVisibleTrackParams)

  const offerMessageWithTracker = useMemo(
    () =>
      offerMessageFromPC && productId !== undefined
        ? getTrackerAddedComboMessageOffer(offerMessageFromPC, productId)
        : offerMessageFromPC,
    [offerMessageFromPC, productId],
  )

  return (
    <>
      {!props.hideOfferMessage && offerMessageWithTracker && (
        <div
          className={classnames(
            styles.offermessage,
            styles.offermessage_adjustedPadding,
            styles.offermessage__offerMessageWithMto,
            styles.offermessage__offerMessageWithMto_adjustedPadding,
            showNewPdpDesignV2 && styles.offermessage_newDesignV2,
          )}
          ref={trackIsVisibleRef}
        >
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: getSanitizedHtml(offerMessageWithTracker),
            }}
          ></div>
        </div>
      )}
    </>
  )
}
